import React from 'react';
import SectionTitle from '../../../components/section-title';
import CustomImage from '../../../components/custom-image';
import CollapseMobile from '../../../components/collapse-mobile';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const WhatDrivesUs = () => {
  return (
    <div className="what-drives-us">
      <div className="container-1440">
        <div className="container">
          <ScrollPositionAnimation targetElement1="anim-4" targetElement2="anim-5">
            <div className="container-inner">
              <div className="content-row">
                <div className="column-45">
                  <div className="left-content">
                    <div className="left-to-right anim-4">
                      <div className="image-box">
                        <CustomImage
                          className="custom-image"
                          imageName="what-drives-us.png"
                          alt="What Drives Us"
                          maxWidth="(max-width: 586)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column-65">
                  <div className="right-content">
                    <div className="bottom-to-top anim-5">
                      <div className="header-title">
                        <SectionTitle
                          lighttext="What drives us"
                          boldtext="Our purpose"
                          alt="What Drives Us"
                          isSectionH1={false}
                        />
                      </div>
                      <div className="description">
                        <p>
                          Our values nurture our culture and underpin our growth and success for the long term. Our
                          ~80,000 strong workforce knows what is critical, how we work together as a team and the way
                          in which growth and sustainable development are at the centre of what we do.
                        </p>
                        <p>
                          These are universal values, which guide us as we expand into unexplored markets and countries.
                          Our people are our best brand ambassadors, who are empowered to drive excellence and
                          innovation and we demonstrate world-class standards of governance, safety, sustainability and
                          social responsibility.
                        </p>
                        {/* <CollapseMobile> */}
                        <p>
                          Our business was built with a simple mission envisioned by the Group’s Chairman, Anil Agarwal:
                          “To create a leading global natural resource Company.” We also make significant contributions
                          to society as we continue to create jobs, thus supporting our host communities through our
                          various social programmes in the areas of childcare, health, education and women empowerment.
                          As one of the largest contributors to the national exchequer, we create and distribute
                          significant value along our entire supply chain.
                          {/* </CollapseMobile> */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default WhatDrivesUs;
